/**
 * Single source of truth for company/brand metadata.
 *
 * Any component that needs the company name, tagline, contact details or the
 * primary call-to-action MUST read it from here. Nothing brand-related should
 * be hard-coded in components.
 */

export const siteConfig = {
  name: "VibeWell",
  legalName: "VibeWell Software Solutions",
  tagline: "Transforming Ideas into Intelligent Digital Solutions.",
  description:
    "VibeWell Software Solutions is a technology solutions company that helps businesses transform ideas into scalable digital solutions through websites, enterprise software, AI-powered automation, mobile applications, cloud technologies and digital transformation services.",
  url: "https://vibewell.live",
  locale: "en_IN",
  business: "Technology Solutions Company",

  /** Primary conversion goal across the whole site. */
  primaryCta: {
    label: "Schedule a Free Consultation",
    path: "/contact",
  },
  secondaryCta: {
    label: "Explore Our Services",
    path: "/services",
  },

  contact: {
    email: "contact@vibewell.live",
    phone: "+91 XXXXX XXXXX",
    address: "India",
  },

  social: {
    twitter: "",
    linkedin: "",
    github: "",
    // dribbble: "coming soon",
  },

  // social: {
  //   twitter: "https://twitter.com/vibewell",
  //   linkedin: "https://linkedin.com/company/vibewell",
  //   github: "https://github.com/vibewell",
  //   dribbble: "https://dribbble.com/vibewell",
  // },
} as const;

export type SiteConfig = typeof siteConfig;
